/* eslint-disable prettier/prettier */
/* eslint-disable */

import { useState } from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import MKBox from "components/MKBox";
import { IconButton } from "@mui/material";
import { TouchApp } from "@mui/icons-material"; // Importer et trykk ikon

function RotatingCard({ children }) {
  const [rotate, setRotate] = useState(false);

  // Denne funksjonen toggler rotasjonen
  const toggleRotate = () => setRotate((prev) => !prev); // Toggle rotasjon

  // Denne funksjonen stopper hendelsen på ikonet fra å propagere videre til kortet
  const handleIconClick = (event) => {
    event.stopPropagation(); // Hindrer at klikk på ikonet trigge kortets onClick
    toggleRotate();
  };

  return (
    <MKBox 
      sx={{ 
        perspective: "50rem", // Gir en 3D-effekt
      }}
    >
      <Card
        sx={{
          backgroundColor: "transparent",
          boxShadow: "none",
          position: "relative",
          transform: rotate ? "rotateY(180deg)" : "rotateY(0)", // Rotasjon basert på tilstanden
          transformStyle: "preserve-3d",
          transition: "transform 0.8s cubic-bezier(0.34, 1.45, 0.7, 1)", // Glatt overgang for rotasjonen
          transformOrigin: "center", // Sørger for at transformasjonen skjer fra midten
          "&:hover": {
            transform: rotate ? "scale(1.05) rotateY(180deg)" : "scale(1.05)", // Poppe ut ved hover, med eller uten rotasjon
            transition: "transform 0.3s ease-in-out", // Glatt overgang for skalering
          },
        }}
        onClick={toggleRotate} // Klikk for å snu kortet
      >
        {children}
        {/* Dette ikonet vil også trigge samme rotasjon, men stoppe propagasjonen */}
        <IconButton
          sx={{
            position: "absolute",
            bottom: "10px", // Plassér ikonet nederst på kortet
            left: "50%",
            transform: "translateX(-50%)", // Sentrere horisontalt
            zIndex: 10,
            padding: 0, // Fjern padding rundt knappen
          }}
          aria-label="trykk meg"
          onClick={handleIconClick}
        >
          <div
            style={{
              width: "30px", // Størrelsen på den hvite sirkelen bak ikonet
              height: "30px", // Størrelsen på den hvite sirkelen bak ikonet
              borderRadius: "50%", // Sirkulær form
              backgroundColor: "white", // Hvitt bakgrunn
              display: "flex",
              justifyContent: "center", // Sentrer ikonet i sirkelen
              alignItems: "center", // Sentrer ikonet i sirkelen
              boxShadow: "0 0 10px 4px rgba(255, 255, 255, 0.8)", // Glød rundt sirkelen
            }}
          >
            <TouchApp
              sx={{
                color: "black", // Endrer fargen på ikonet for kontrast med bakgrunnen
                fontSize: "30px", // Størrelsen på ikonet
              }}
            />
          </div>
        </IconButton>

      </Card>
    </MKBox>
  );
}

RotatingCard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RotatingCard;
